// The arithmetic of the home carousel (full phase 102, `doc/site-layout.md`
// 5.4.2), apart from the DOM so it is tested on its own: which photo comes
// next or before, wrapping at both ends; which photo the row shows at a
// scroll position; and whether the carousel may turn on its own at all. The
// day's first photo is the server's (`SiteLayout::PageAssembly.home_window`):
// the row opens on the first slide it rendered.

// One photo every six seconds while nothing holds the carousel still.
export const AUTOPLAY_INTERVAL_MS = 6000

export function nextIndex(index: number, count: number): number {
  return count > 0 ? (index + 1) % count : 0
}

export function previousIndex(index: number, count: number): number {
  return count > 0 ? (index - 1 + count) % count : 0
}

// The slide in view: the nearest whole slide to the scroll position. A
// right-to-left row reports a negative position, so the distance counts.
export function indexAt(scrollLeft: number, slideWidth: number, count: number): number {
  if (count <= 0 || slideWidth <= 0) return 0

  return Math.min(count - 1, Math.max(0, Math.round(Math.abs(scrollLeft) / slideWidth)))
}

// A carousel turns on its own only with somewhere to turn to and never for
// a visitor who asked the system for less motion; the controls stay either
// way.
export function shouldAutoplay(count: number, reducedMotion: boolean): boolean {
  return count > 1 && !reducedMotion
}
